import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React, { useEffect, useState } from 'react';
import VideoThumbnail from '../VideoThumbnail/VideoThumbnail';

const VideoGrid = ({videos}) => {
    const [loadedVideos, setLoadedVideos] = useState([]);

    useEffect(() => {
        if (videos !== undefined && videos.length !== 0) {
            setLoadedVideos(videos);
        }
    }, [videos]);

    return (
        <Grid2 container spacing={3}>
            {
                loadedVideos.map((video) => (
                    <Grid2 xs={4}>
                        <VideoThumbnail video={video} />
                    </Grid2>
                ))
            }
        </Grid2>
    );
}

export default VideoGrid;